export default __webpack_public_path__ + "static/media/026-road.08556abb.svg";